import { render, staticRenderFns } from "./DisputeCaseDetails.vue?vue&type=template&id=1073641e"
import script from "./DisputeCaseDetails.vue?vue&type=script&lang=js"
export * from "./DisputeCaseDetails.vue?vue&type=script&lang=js"
import style0 from "./DisputeCaseDetails.vue?vue&type=style&index=0&id=1073641e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports